import Divider from "@components/common/Divider";
import Destinations from "@components/packageComponents/Destinations";
import { JSON_SCHEMAS } from "@components/utils/constants";
import { IPackageResponse } from "@customTypes/modelResponses";
import JsonLdSchema from "@libs/schema/JsonLdSchema";

interface IPackagePageTopSectionProps {
  data: IPackageResponse;
}
// https://cms.devcrvtestingmm.com/admin/content-manager/collectionType/api::package.package/161
// Property: locations
const PackagePageTopSection = ({
  data,
}: IPackagePageTopSectionProps): JSX.Element => {
  return (
    <>
      <JsonLdSchema
        data={{
          breadcrumbObjects: undefined,
          schema: undefined,
          content: data,
        }}
        type={JSON_SCHEMAS.TRIP}
      />
      <div className="w-[100%] px-5 desktop:w-[100%] desktop:px-0">
        <Destinations
          data={data.locations}
          description={data.Locations_Intro_Text}
          hasRaQ={true}
        />
      </div>
      <Divider variant="short" />
    </>
  );
};

export default PackagePageTopSection;
